<template>
  <div class="telCodeInput">
    <div class="tel-header">
      <p class="title">登录/注册少年得到</p>
      <p class="desc">该手机号将用于开通课程</p>
    </div>
    <!-- 电话 -->
    <div class="content">
      <div class="showSelect left" v-fastclick="showSelect">
        +{{select.value}}
        <span class="igetcool cool-sanjiao"></span>
      </div>
      <div class="phone">
        <input type="tel" placeholder="请输入手机号" v-model="phone" :maxlength="maxPhonelength" @blur="inputDown"/>
      </div>
    </div>
    <!-- 验证码 -->
    <div class="content yanzhengma-wrap">
      <span class="left">验证码</span>
      <div class="phone">
        <input placeholder="请输入验证码" v-model="code" type="number" @blur="inputDown"/>
      </div>
      <div class="clear_wrap"
           @click="clearCodeHandle"
           v-show="clearCode">
        <IClear/>
      </div>
      <button v-fastclick="sendCode" v-log:click="{...log, name: '获取验证码'}" :class="`getCode ${ifStart?'disactive':''}`">
        {{ifStart?nowTime+'s':'获取验证码'}}
      </button>
    </div>
    <!-- 提交按钮 -->
    <IButton size="large" height="5" text="立即登录"
             v-log="{name: '立即登录'}"
             :disabled="disabled"
             @i-click="loginHandle"
    />
    <Country-select :select="select" @select="selectTel"></Country-select>
    <ILoading
      :visible="loadingVisible"/>
  </div>
</template>

<script>
import CountrySelect from './CountrySelect/countrySelect';
import { IButton } from '@/components/IButton';
import { ILoading } from '@/components/ITag';
import { IClear } from '@/components/IIcon';
import { httpRequest } from '@utils';
import { get } from '@/utils/request';
import { login } from '@/api/user';
import { validateMobile } from '@utils/validate.js';
import { encryptRsa } from '@utils/encryptRsa';
export default {
  name: 'telCodeInput',
  components: { CountrySelect, IButton, ILoading, IClear },
  props: {
    log: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dataResult: {
      type: Object,
      default: function() {
        return {};
      }
    },
    from: {
      type: Object,
      default: function() {
        return {
          userChannel: 'share'
        };
      }
    }
  },

  data() {
    let { h5Pid } = this.$route.query;
    if (location.href.indexOf('inviteCoupon') != -1) {
      h5Pid = '';
    }
    return {
      select: {
        show: false,
        value: 86
      },
      h5Pid,
      isShowToast: false,
      warningWords: '',
      ifStart: false,
      fullTime: 60,
      nowTime: 60,
      code: '',
      phone: '',
      maxPhonelength: 11,
      phoneStatus: false,
      codeStatus: false,
      loadingVisible: false,
      timer: null
    };
  },
  computed: {
    disabled() {
      return !(this.code && this.phone);
    },
    clearCode() {
      return this.code;
    }
  },
  methods: {
    clearCodeHandle() {
      this.code = '';
    },
    inputDown() {
      window.scroll(0, 0);
    },
    nowToRegister() {
      if (!this._handleIfReg()) {
        return;
      }
      this._registerAjax();
    },
    _handleIfReg() {
      let phoneStatus = validateMobile(this.phone, this.select.value);
      let codeStatus = this.code.length === 4;
      this.phoneStatus = phoneStatus;
      this.codeStatus = codeStatus;
      if (!phoneStatus) {
        this.$coolToast({
          text: '手机号码格式不正确',
          time: 3000
        });
        return false;
      }
      if (!this.codeStatus) {
        this.$coolToast({
          text: '验证码格式不正确',
          time: 3000
        });
        return false;
      }
      return true;
    },
    _registerAjax() {
      let userChannel = this.from.userChannel;
      let _from = location.search.match(/[&|?]from=([^&]*)/);
      if (_from && _from[1]) {
        userChannel = _from[1];
      }
      const { spm } = this.$route.query;
      httpRequest
        .post('/app-api-user-server/white/code/h5Register.json', {
          phone: this.phone,
          countrycode: this.select.value || 86,
          smscode: this.code,
          shareUserPid: this.dataResult.userId,
          h5Pid: this.h5Pid,
          userChannel,
          spm
        })
        .then(res => {
          if (res.code === 10000) {
            this.$emit('onSubmit', res.code);
          } else {
            this.$coolToast({
              text: res.friendlyMsg,
              time: 3000
            });
          }
        })
        .catch(err => {

          // console.log(err)
        });
    },

    // 发送验证码事件
    sendCode() {
      let phoneStatus = validateMobile(this.phone, this.select.value);
      if (!phoneStatus) {
        this.$coolToast({
          text: '手机号码格式不正确',
          time: 3000
        });
        return;
      }
      if (this.ifStart) {
        return;
      }

      this._nowGetCode();
    },
    _handleTimer() {
      if (this.timer) { clearInterval(this.timer) }
      this.timer = setInterval(() => {
        this.nowTime = this.nowTime - 1;
        if (this.nowTime === 0) {
          this.ifStart = false;
          this.nowTime = this.fullTime;
          clearTimeout(this.timer);
        }
      }, 1000);
    },

    // 发送验证码请求
    _nowGetCode() {
      let phone = encryptRsa(this.phone);
      get('smscode/sendSmscode', {
        phone,
        countrycode: this.select.value || 86,
        smstype: 0,
        type: 0
      })
        .then(res => {
          if (res.code === 10000) {
            this.ifStart = true;
            this._handleTimer();
          } else {
            this.ifStart = true;
            this._handleSendCode(res);
          }
        })
        .catch(err => {
          this.ifStart = true;
          this._handleSendCode(err);
        });
    },
    _handleSendCode(res) {
      if (res.code === 400011) {
        this.$coolToast({
          text: '手机号已注册',
          time: 3000
        });
      } else {
        this.$coolToast({
          text: '请检查网络是否连接',
          time: 3000
        });
      }
    },

    // 选择器事件
    showSelect() {
      this.select.show = true;
    },
    selectTel(select) {
      this.select = select;
      if (select.value !== 86) {
        this.maxPhonelength = 1000;
      } else {
        this.maxPhonelength = 11;
      }
    },
    async loginHandle() {
      if (!this._handleIfReg()) {
        return;
      }
      const opt = {};
      opt.countrycode = this.select.value;
      opt.phone = encryptRsa(this.phone);
      opt.smscode = encryptRsa(this.code);
      opt.spm = this.$route.query.spm;
      this.loadingVisible = true;
      try {
        const { data } = await login(opt);
        this.loadingVisible = false;
        this.$emit('onSubmit', { ...data, phone: this.phone });
      } catch (err) {
        this.loadingVisible = false;
        if (err.message === 'Network Error') {
          this.$coolToast({ text: '请检查网络连接' });
        }

        // else {
        //   this.$coolToast({ text: err.msg });
        // }
      }
    }
  },

  watch: {
    phone(val) {
      this.phoneStatus = validateMobile(val, this.select.value);
      this.codeStatus = this.code.length === 4;
    },
    code(val) {
      if (val.length > 4) { this.code = val.slice(0, 4) }
      this.codeStatus = val.length === 4;
      this.phoneStatus = validateMobile(this.phone, this.select.value);
    }
  }
};
</script>

<style lang="stylus">
  .telCodeInput {
    font-size 0.14rem
    background-color #fff
    margin 0 auto
    box-sizing border-box

    .tel-header {
      color #41414d
      text-align center
      margin-bottom 32px

      .title {
        line-height 30px
        font-size 24px
        color #41414D
        margin-top 40px
        font-weight 500
      }

      .desc {
        line-height 20px
        font-size 14px
        color #6D6D80
        margin-top 8px
      }

      .tips {
        font-size 0.14rem
        width 2.95rem
        height 0.34rem
        line-height 0.34rem
        background-color #fff9e0
        border-radius 0.08rem
        color #663300

        .active {
          /*color #FF5F2E;*/
        }
      }
    }

    .content {
      height 0.44rem
      display flex
      margin 0 auto 30px
      border-bottom 0.01rem solid #e6e6eb
      align-items center

      .showSelect {
        font-size 0.16rem
        display flex
        align-items center

        .cool-sanjiao {
          font-size 0.14rem
          color #c6c7cb
        }
      }

      .left {
        width 0.64rem
        color #41414d
        font-size 0.16rem
      }

      .phone {
        flex 1

        input {
          width 100%
          border none
          outline none
          font-size 0.16rem
        }

        input:

        :-webkit-input-placeholder {
          /* placeholder颜色  */
          color #d4d4d9
        }
      }

      .getCode {
        display inline-block
        color #ff5f2e
        font-size 0.14rem
        border none
        outline none
        background-color #ffffff
        margin-left auto

      }

      .disactive {
        color #d4d4d9
      }
    }

    .yanzhengma-wrap {
      margin-top 0.2rem

      /*background-color #00ae66;*/
    }

    .now-get {
      width 2.95rem
      height 0.5rem
      background-color #d7d6d6
      outline none
      border none
      color #fff
      margin 0 auto
      display block
      border-radius 0.25rem
      font-size 0.18rem
      margin-top 0.3rem

      &.active {
        background-color #ff5f2e
      }
    }
  }

  .clear_wrap {
    width 18px
    height 18px
    font-size 0
    margin-right 5px
  }
</style>
